module.exports = __webpack_public_path__ + "img/belov.284556f6.png";